import { Brand as TypeBrand, createBranded } from '@deltasierra/type-utilities';

export type ClientId = TypeBrand<number, 'ClientId'>;
export const ClientId = createBranded<ClientId>();
